module.exports = __webpack_public_path__ + "img/close.a3c3de7.png";